import { render, staticRenderFns } from "./QuoteAttachment.vue?vue&type=template&id=0b775eb3"
import script from "./QuoteAttachment.vue?vue&type=script&lang=js"
export * from "./QuoteAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b775eb3')) {
      api.createRecord('0b775eb3', component.options)
    } else {
      api.reload('0b775eb3', component.options)
    }
    module.hot.accept("./QuoteAttachment.vue?vue&type=template&id=0b775eb3", function () {
      api.rerender('0b775eb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteAttachment.vue"
export default component.exports